import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

/* DTO basico para representar o estado corrente de uma entidade no modelo */
export class Estado extends BaseEntity {

    public nomeEstado: string;
    public motivoEstado: string;
}

export const CODIGO_ESTADO_ATV_S_VINC: number = 11;
